import React from "react"
import { cn } from "@malond/ui/utils"

export default function Label({
  htmlFor,
  isError,
  children,
  className,
}: {
  htmlFor?: string
  isError?: boolean
  children?: any
  className?: string
}) {
  return (
    <label
      htmlFor={htmlFor}
      className={cn(
        "block text-sm font-medium",
        isError ? "text-destructive" : "text-foreground",
        className
      )}
    >
      {children}
    </label>
  )
}
